<mat-form-field appearance="fill" style="margin-bottom: 0;">
    <mat-label>Date range</mat-label>
    <mat-date-range-input [formGroup]="dateRangeForm" [rangePicker]="picker">
        <input matInput matStartDate formControlName="start" placeholder="Start date">
        <input matInput matEndDate formControlName="end" placeholder="End date">
    </mat-date-range-input>
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker>
        <mat-datepicker-actions>
            <button mat-raised-button class="button" matDatepickerCancel (click)="clearDates()">Clear</button>
            <button mat-raised-button class="button" matDatepickerApply (click)="handleDateChange()">Apply</button>
        </mat-datepicker-actions>
    </mat-date-range-picker>
</mat-form-field>
